<template>
	<div class="CustomSelect materialElement">
		<label class="label" v-if="label">{{ label }} <span
				v-if="optional">{{ lang.common.optional }}</span></label>
		<select :name="dataKey" v-model="value">
			<option v-for="item in values" :key="item.value" :value="item.value">{{ item.label }}</option>
		</select>
		<div v-show="helperText" class="helper">
			<div ref="helperTextContent"
					 class="helperTextContent littleAndBold">{{ helperText }}
			</div>
		</div>
	</div>
</template>

<script>
import lang from '../lang'
import {mapActions} from 'vuex'

export default {
	name: 'Select',
	props: {
		label: String,
		dataKey: String,
		default: String,
		values: Array,
		placeholder: String,
		helperText: String,
		optional: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			value: this.$store.state[this.dataKey] || this.default,
			lang,
		}
	},
	watch: {
		value(newValue) {
			this.setPartnerDataValue({ key: this.dataKey, value: newValue })
			this.$emit('selectValueChanged', newValue)
		},
	},
	methods: {
		...mapActions(['setPartnerDataValue']),
	}
}
</script>

<style lang="stylus" scoped>
.CustomSelect {
	position: relative;
	margin: 8px 0;
	width: 100%;
}

.CustomSelect > label {
	display: block;
	font-size: 13px;
	color: #888;
	transition: color 0.15s;
}

.CustomSelect > select {
	display: block;
	border: none;
	width: 100%;
	height: 32px;
	font-size: 16px;
	outline: none;
	margin: 0;
	padding: 0;
	caret-color: #159880;
	background: transparent;
}

.CustomSelect::after {
	box-sizing: border-box;
	content: ' ';
	display: block;
	width: 100%;
	height: 2px;
	border-bottom: 1px solid #888;
	position: relative;
	top: -3px;
	transition: border-color 0.2s;
}

@media screen and (max-width: 1300px) {
	.helper {
		display: none;
	}
}

.helper {
	position: absolute;
	top: 0px;
	right: -340px;
	width: 300px;
	height: 60px;
	background: #eee;
	z-index: 100;
	border-top-right-radius: 6px;
	border-bottom-right-radius: 6px;
	padding: 5px;
	font-size: 13px;
	line-height: 1.15rem;
	box-sizing: border-box;
	opacity: 0;
	transition: all 0.3s;

	.helperTextContent {
		width: calc(100% - 20px);
		position: absolute;
		left: 10px;
		top: 50%;
		transform: translateY(-50%);
		z-index: 1000;
	}
}

.helper::before {
	content: '';
	position: absolute;
	top: 0;
	background: #eee;
	z-index: -4;
	left: -30px;
	height: 60px;
	width: 60px;
	transform: rotate(45deg) scale(0.707106781187);
}

.CustomSelect:focus-within .helper {
	opacity: 1;
}
</style>
